import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var MediaStreamHelper = function () {
  function MediaStreamHelper() {
    _classCallCheck(this, MediaStreamHelper);
  }

  _createClass(MediaStreamHelper, null, [{
    key: "getLocalMediaStream",
    value: function getLocalMediaStream() {
      var constraints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var oldStreamToStop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var self = this;
      return new Promise(function (resolve, reject) {
        if (constraints == null) {
          constraints = {
            video: {
              facingMode: {
                exact: "user"
              }
            },
            audio: true
          };
        }

        if (oldStreamToStop) {
          oldStreamToStop.getVideoTracks().forEach(function (track) {
            track.stop();
          });
        }

        navigator.getUserMedia(constraints, function (mediaStream) {
          resolve(mediaStream);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getConstraints",
    value: function getConstraints() {
      var videoRequired = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var audioRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var cameraOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "user";
      var constraints = null;

      if (cameraOption != null) {
        constraints = {
          video: {
            facingMode: cameraOption
          },
          audio: true
        };
      } else {
        constraints = {
          video: true,
          audio: true
        };
      }

      return constraints;
    }
  }, {
    key: "pictureInPicture",
    value: function () {
      var _pictureInPicture = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(elementid, activate) {
        var videoElement;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoElement = document.getElementById(elementid);
                _context.prev = 1;

                if (!activate) {
                  _context.next = 8;
                  break;
                }

                if (!(videoElement !== document.pictureInPictureElement)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return videoElement.requestPictureInPicture();

              case 6:
                _context.next = 11;
                break;

              case 8:
                if (!document.pictureInPictureElement) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return document.exitPictureInPicture();

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                console.log("Browser doesn't have picture-in-picture capability");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13]]);
      }));

      function pictureInPicture(_x, _x2) {
        return _pictureInPicture.apply(this, arguments);
      }

      return pictureInPicture;
    }()
  }, {
    key: "closeMediaStream",
    value: function closeMediaStream(mediaStream) {
      if (!mediaStream) return;
      mediaStream.getTracks().map(function (track) {
        try {
          track.stop();
        } catch (ex) {}
      });
    }
  }, {
    key: "setAudioStatus",
    value: function setAudioStatus(mediaStream, status) {
      if (!mediaStream) return;
      mediaStream.getAudioTracks().forEach(function (track) {
        track.enabled = status;
      });
    }
  }, {
    key: "setVideoDisplayStatus",
    value: function setVideoDisplayStatus(mediaStream, isHidden) {
      if (!mediaStream) return;
      mediaStream.getVideoTracks().forEach(function (track) {
        track.enabled = !isHidden;
      });
    }
  }]);

  return MediaStreamHelper;
}();